module.exports = __webpack_public_path__ + "static/media/ic-close.cd852c93.svg";